import { type SpacingToken } from '@/theme/tokens';
import { DialogLayout } from '@/ui/composites/DialogLayout';
import { dialogRhythm } from '@/ui/composites/dialogRhythm';
import { Button, type ButtonProps, type DialogProps } from '@/ui/primitives';
import type { ReactNode } from 'react';

type InfoDialogProps = {
  open: boolean;
  title: string;
  description?: ReactNode;
  children: ReactNode;
  closeLabel?: string;
  closeVariant?: ButtonProps['variant'];
  scroll?: DialogProps['scroll'];
  contentOffset?: SpacingToken;
  width?: 'standard' | 'wide';
  onClose: () => void;
};

export const InfoDialog = ({
  open,
  title,
  description,
  children,
  closeLabel = 'Close',
  closeVariant = 'secondary',
  scroll = 'paper',
  contentOffset = dialogRhythm.contentOffset,
  width = 'standard',
  onClose,
}: InfoDialogProps): ReactNode => (
  <DialogLayout
    open={open}
    onClose={onClose}
    title={title}
    description={description}
    scroll={scroll}
    headerGap={dialogRhythm.headerGap}
    contentOffset={contentOffset}
    footerGap={dialogRhythm.footerGap}
    width={width}
    actions={
      <Button variant={closeVariant} onClick={onClose}>
        {closeLabel}
      </Button>
    }
    actionsAlign="flex-end"
  >
    {children}
  </DialogLayout>
);
